import { environment } from '@/shared/consts/environment'

export const validateUrl = (url: string) => {
  if (environment.env === 'development') {
    return (
      url.match(
        /^(?:(?:https?):\/\/)?(?:[\w-]+\.)+[a-z]{2,6}(?:\/[\w#!:.?+=&%@!-/]*)?$/
      ) || url.includes('localhost')
    )
  }
  return url.match(
    /^(?:(?:https?):\/\/)?(?:[\w-]+\.)+[a-z]{2,6}(?:\/[\w#!:.?+=&%@!-/]*)?$/
  )
}
